var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "errors-list-container" }, [
    _c("div", { staticClass: "errors-list-title" }, [
      _vm._v(_vm._s(_setup.texts.body)),
    ]),
    _c(
      "ul",
      { staticClass: "errors-list" },
      _vm._l(_setup.props.errors, function (messageError) {
        return _c("li", { staticClass: "errors-list-item" }, [
          _c("div", { staticClass: "errors-list-item-img" }, [
            _c("img", { attrs: { src: _setup.icon } }),
          ]),
          _c("span", { domProps: { innerHTML: _vm._s(messageError) } }),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }